/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h3: "h3",
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td",
    code: "code",
    em: "em"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h3, {
      children: "Standard data value component props"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Property"
          }), _jsx(_components.th, {
            children: "Type"
          }), _jsx(_components.th, {
            children: "Description"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "className"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "string"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " Outer DOM element class name"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "value"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: props.type
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " Source data value for the input"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "layout"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "string"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " Layout for the label and input. Can be ", _jsx(_components.code, {
              children: "horizontal"
            }), " or ", _jsx(_components.code, {
              children: "vertical"
            })]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "label"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "string"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " Field label to show above / before the input feature"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "labelDescription"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "string"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " A more discreet text displayed beside the label (i.e for \"(optional)\")"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "labelSecondary"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "string"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " Secondary information displayed at the end of the label line (i.e character counter)"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "placeholder"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "string"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " Text showing in place of the value if no value is given"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "path"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "string"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " JSON Pointer for where the data for this input is located in the source dataset (when using DataContext)"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "info"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "Error"
            }), " or ", _jsx(_components.code, {
              children: "string"
            })]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " Info message shown below / after the input"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "warning"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "Error"
            }), " or ", _jsx(_components.code, {
              children: "string"
            })]
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " Warning message shown below / after the input"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "error"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "Error"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " Error message shown below / after the input"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "disabled"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "boolean"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " Set ", _jsx(_components.code, {
              children: "true"
            }), " to show the field but without the possibility of changing the value."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "emptyValue"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "any"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " The value to use (in ", _jsx(_components.code, {
              children: "onChange"
            }), " events etc) when emptying the field. Makes it possible for instance to provide ", _jsx(_components.code, {
              children: "undefined"
            }), " instead of an empty string when clearing the content of a text input."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "required"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "boolean"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " When set ", _jsx(_components.code, {
              children: "true"
            }), ", the input will give an error if the value cannot be empty."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "schema"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "object"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " Custom JSON Schema for validating the value."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "validateInitially"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "string"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " Set true to show validation based errors initially (from given value-prop or source data) before the user interacts with the field."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "validateUnchanged"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "string"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " Set true to show validation based errors when the field is touched (like focusing a field and blurring) without having changed the value. Since the user did not introduce a new error, this will apply when the value was initially invalid based on validation."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "continuousValidation"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "string"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " Set true to show validation based errors continuously while writing, not just when blurring the field."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "errorMessages"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "object"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " Custom error messages for each type of error, overriding default messages."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "validator"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "function"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " Custom validator function that will be called for every change done by the user. Can be asynchronous or synchronous."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "onBlurValidator"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "function"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " Custom validator function that will be called when the user leaves the field (blurring a text input, closing a dropdown etc). Can be asynchronous or synchronous."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "toInput"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "function"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " Derivate called when the received / active value is sent to the input. Can be used for casting, changing syntax etc."]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "fromInput"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "function"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.em, {
              children: "(optional)"
            }), " Derivate called when changes is made by the user, to cast or change syntax back to the original (opposite of ", _jsx(_components.code, {
              children: "toInput"
            }), ")."]
          })]
        })]
      })]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
